// We want to call this generic Checkbox so we need a named default import for the MUI Checkbox it uses.
import { default as MUICheckbox } from '@mui/material/Checkbox';
import * as _ from 'lodash';
import type { ChangeEvent, VoidFunctionComponent } from 'react';

import css from './Checkbox.module.less';

type CheckboxProps = {
  id?: string;
  isChecked: boolean;
  isDisabled?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  testId?: string;
  /**
   * If the MUI ripples should be disabled or not
   */
  isRippleDisabled?: boolean;
  isIndeterminate?: boolean;
  shouldStopPropagation?: boolean;
};

/**
 * Wrapper for MaterialUI's <Checkbox />
 * More aligned with the old Checkbox component API
 */
const Checkbox: VoidFunctionComponent<CheckboxProps> = ({
  id,
  isChecked,
  isDisabled,
  onChange = _.noop,
  testId,
  isRippleDisabled,
  isIndeterminate,
  shouldStopPropagation,
}) => {
  return (
    <MUICheckbox
      id={id}
      checked={isChecked}
      onClick={(event) => {
        if (shouldStopPropagation) {
          event.stopPropagation();
        }
      }}
      onChange={onChange}
      data-test-id={testId}
      indeterminate={isIndeterminate}
      color="primary"
      disableRipple={isRippleDisabled}
      disableFocusRipple={isRippleDisabled}
      disableTouchRipple={isRippleDisabled}
      disabled={!!isDisabled}
      className={css.checkbox}
    />
  );
};

export default Checkbox;
